import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { request } from '../../service/common';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, } from '@material-ui/core';
import { toast } from 'react-toastify';
import { addUser, getUserById, editUser } from '../../store/user';
import { useDispatch } from 'react-redux';

const UserCreateEdit = () => {
    const dispatch = useDispatch()
    let { id }: any = useParams();
    const [user, setUser] = useState<any>({})
    const [loder, setLoder] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const signupSchema = yup.object().shape({
        first_name: yup.string().required('First name is required!'),
        last_name: yup.string().required('Last name is required!'),
        email: yup.string().email().required('Email is required!'),
        password: yup.string().when('isEdit', {
            is: false,
            then: yup.string()
                .required('Password is required!'),
            otherwise: yup.string(),

        })
    });
    let history = useHistory();
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(signupSchema),
        defaultValues: {
            first_name: '',
            last_name: '',
            email: '',
            password: ''
        }
    });

    useEffect(() => {
        if (id) {
            setIsEdit(true);
            getUser();

        }
    }, [])

    const getUser = async () => {
        dispatch(getUserById(id)).then((user: any) => {
            if (user.payload.data) {
                let data = user.payload.data
                setValue("first_name", data.first_name);
                setValue("last_name", data.last_name);
                setValue("email", data.email);
            }

        })
    }
    const onSubmit = async (data: any) => {
        if (isEdit) {
            dispatch(editUser({ id: id, data: data })).then((data: any) => {
                if (data.error) {
                    toast.error('Error in user update', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    history.push("/user-list")

                }
            })

        } else {
            dispatch(addUser(data)).then((data: any) => {
                if (data.error) {
                    console.log(data.error)
                    toast.error('Error in user create', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    history.push("/user-list")

                }
            })

        }

    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-9 card ">
                    <div className="card-header bg-transparent">
                        {!isEdit && <h2>Create User</h2>}
                        {isEdit && <h2>Edit User</h2>}
                    </div>
                    <div className="card-body">

                        <div className="formContent p-0">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-3">
                                    <label className="form-label">First name</label>
                                    <input className="form-control"  {...register("first_name")} placeholder="First name" />
                                    <p className="error">{errors.first_name?.message}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Last name</label>
                                    <input className="form-control"   {...register("last_name")} placeholder="Last name" />
                                    <p className="error">{errors.last_name?.message}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input className="form-control"  {...register("email")} placeholder="Email" />
                                    <p className="error">{errors.email?.message}</p>
                                </div>
                                {!isEdit &&
                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <input className="form-control"  {...register("password")} placeholder="Password" type="password" />
                                        <p className="error">{errors.password?.message}</p>
                                    </div>
                                }
                                <Button variant="contained" color="primary" type="submit">
                                    Submit
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


}
export default UserCreateEdit;